import {IDateTimeWithZone} from '../common/date-time-with-zone.interface';
import {ITrainingType} from './training-record-type.interface';
import {DateTimeWithZone} from '../common/date-time-with-zone.class';
import { ITrainingTypeCategoryInfo } from './trainning-record-category.interface';
import { TrainingTypeCategoryInfo } from './trainning-record-category.class';

export class TrainingType implements ITrainingType {
  companyId: string;
  id: string;
  name: string;
  description: string;
  heldOn: IDateTimeWithZone;
  isSelected = false;
  validTo: IDateTimeWithZone;
  trainingTypeCategory: ITrainingTypeCategoryInfo;
  trainingTypeCategoryId: string;
  trainingTypeCategoryName: string;
  constructor(iTrainingType: ITrainingType = null) {
    this.companyId = iTrainingType?.companyId;
    this.id = iTrainingType?.id;

    this.name = iTrainingType?.name || '';
    this.description = iTrainingType?.description || '';
    this.validTo = new DateTimeWithZone(iTrainingType?.validTo);
    this.heldOn = new DateTimeWithZone(iTrainingType?.heldOn);

    this.trainingTypeCategory = iTrainingType?.trainingTypeCategory;
    this.trainingTypeCategoryId = iTrainingType?.trainingTypeCategoryId;
    this.trainingTypeCategoryName = iTrainingType?.trainingTypeCategoryName;

  }

  get isValid(): boolean {
    return !!this.name;
  }

}
